export default __webpack_public_path__ + "static/media/949666.a4054b8a.svg";